<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" translate>
        <!-- lblAddAppointment -->
        lblTecRmiMaintenance
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="OnDismiss()" aria-label="Center Align">
        <span aria-hidden="true">
            ×
        </span>
    </button>
</div>
<div class="modal-body p-0  min-h500">
    <div class="card pad15">
        <div class="row justify-content-between" *ngIf="currentVehicleDetails">
            <div class="col-auto">
                <div class="af-form-group"><label translate>lblRegNumber</label>
                    <div class="lbl-info">
                        <div class="flmid">
                            <div class="licplate LPNo d-flex"><span class="icn-flag"
                                    [ngClass]="licensePlateClass"></span>
                                {{appointmentDetails.licensePlate}} </div>
                            <div class="imgWid">
                                <img af-brand-logo data-type="BRAND" [data-code]="appointmentDetails.brandCode" class="{{appointmentDetails.brand.name}}-icon common brandicon" alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="af-form-group"><label translate>lblMake</label>
                    <div class="lbl-info"> {{currentVehicleDetails.companyMakeName}} </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="af-form-group"><label translate>lblModel</label>
                    <div class="lbl-info"> {{currentVehicleDetails.companyModel}} </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="af-form-group"><label translate>lblEngineNo</label>
                    <div class="lbl-info"> {{currentVehicleDetails.mchCode}}</div>
                </div>
            </div>
            <div class="col-auto">
                <div class="af-form-group"><label translate>lblVinNumber</label>
                    <div class="lbl-info"> {{currentVehicleDetails.chassisNo}} <button placement="top"
                            ngbtooltip="Copy VIN" aria-label="Center Align" class="btn btn-link ml-2"
                            ng-reflect-placement="top" ng-reflect-ngb-tooltip="Copy VIN"><em
                                class="fas fa-copy fa-lg"></em></button>

                    </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="af-form-group"><label translate>lblMileage</label>
                    <div class="lbl-info ng-star-inserted"> {{currentVehicleDetails.mileage}} &nbsp;KM </div>

                </div>
            </div>
            <div class="col-auto">
                <div class="af-form-group"><label translate>lblFuelType</label>
                    <div class="lbl-info"> {{currentVehicleDetails.fuelType}} </div>
                </div>
            </div>
            <div class="col-auto">
                <div class="af-form-group"><label translate>lblRegistrationDate</label>
                    <div class="lbl-info">{{ currentVehicleDetails.dmsRegistrationDate | date: 'dd.MM.yyyy' }}</div>
                </div>
            </div>
            <div class="col-auto">
                <div class="af-form-group"><label translate>lblYear</label>
                    <div class="lbl-info"> {{currentVehicleDetails.year}} </div>
                </div>
            </div>
        </div>

    </div>
    <div class=" min-h250">
        <ul class="nav-tabs nav">
            <li *ngFor="let tab of tabs" class="nav-item">
                <ng-container *ngIf="tab">
                    <a translate class="nav-link" (click)="selectedtab=tab.id"
                        [ngClass]="{'active': selectedtab==tab.id,'disabled': tab.disable===true }">{{tab.name}}</a>
                </ng-container>
            </li>
        </ul>

        <!-- Show validation for Quantity -->
        <div class="form-row text-exclamation p-2 d-flex align-items-center"
            *ngIf="selectedtab == 6 && isErrorOnStockBalanceStep" style="margin-left: 6px;">
            <em class="fas fa-exclamation-circle fa-lg align-middle" style="vertical-align: middle;color:red"></em>
            <span translate class="ml-2 mr-2"
                style="font-size: small;font-style: italic;color:red">lblQuantityLessThanOne</span>
        </div>


        <div class="ctm-tab custom-card">
            <ng-cotainer *ngIf="selectedtab==1">
                <div class="pad15">
                    <div class="row">
                        <div class="col-4">
                            <div class="af-form-group">
                                <label translate>lblMileage</label>
                                <div class="lbl-nfo">
                                    <input type="number" [(ngModel)]="filterModel.currentMileage" class="form-control"
                                        (change)="changeMileage($event)">
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="af-form-group">
                                <label translate>lbl1stRegistrationDate</label>
                                <div class="lbl-info cal-date">
                                    <input class="form-control datePicker width100force" appAfDatepicker
                                        autocomplete="off" [(ngModel)]="filterModel.regDate" [startDate]="'1900/01/01'"
                                        [dateTime]="false" id="regDate" name="regDate" type="text" value=""
                                        [endDate]="endDate" [ngModelOptions]="{standalone: true}"
                                        (OnSelect)="changeDate($event)">
                                    <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                                </div>
                            </div>
                        </div>

                        <div class="col-4">
                            <div class=" af-form-group">
                                <label translate>lblTransmissionType<span class="text-danger"> * </span></label>
                                <div class="lbl-info" style="width: 100%">
                                    <ng-select [(ngModel)]="filterModel.kindOfGearBox" name="gearBox"
                                        placeholder="{{ 'lblSelectGearBox' | translate }}"
                                        (change)="onGearBoxChanged($event)">
                                        <ng-option *ngFor="let gearBox of gearBoxList" [value]="gearBox.key">
                                            {{ gearBox.value }}
                                        </ng-option>
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </ng-cotainer>
            <ng-cotainer (click)="getCooGroupList();" *ngIf="selectedtab==2">

                <div class="pad15">
                    <div class="row">
                        <div class="col-10">
                            <div class="af-form-group">
                                <label translate>lblSelectVariant<span class="text-danger"> * </span></label>
                                <div class="lbl-info" style="width: 100%">
                                    <ng-select [(ngModel)]="filterModel.cooGroupId" name="cooGroup"
                                        placeholder="{{ 'lblSelectVariant' | translate }}">
                                        <ng-option *ngFor="let grp of cooGroupList" [value]="grp.cooGroupId">
                                            {{ grp.cooGroupName }}
                                        </ng-option>
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </ng-cotainer>
            <ng-cotainer (click)="getServiceProposal();" *ngIf="selectedtab==3">

                <div class="pad15">
                    <div class="row">
                        <div class="col-12 flexbox form-check">
                            <input type="radio" class="radio-custom m-0" id="service" name="offerservice" [value]="true"
                                [(ngModel)]="selectedProposal" (change)='onProposalChange($event)' />
                            <label translate class="text-dark ml-2 bold font17 mt-1" for="service">
                                lblPreviousService
                                <br />
                                <span *ngIf="LastKilometer" translate>
                                    lblPreviousKm
                                    <span>
                                        : {{LastKilometer}}
                                    </span>
                                </span>
                                <br />
                                <span *ngIf="LastDate" translate>
                                    lblPreviousDate
                                    <span>
                                        : {{ LastDate | date: 'dd.MM.yyyy' }}
                                    </span>
                                </span>

                            </label>
                        </div>
                        <div class="col-12 form-check mt-2"
                            *ngIf="serviceProposal && serviceProposal.previousServiceInfo && serviceProposal.previousServiceInfo.length > 0">

                            <p class="font14 form-check italic" [id]="item.workId"
                                *ngFor="let item of serviceProposal.previousServiceInfo">
                                <em class="fas fa-check"></em> {{ item.serviceName}}
                            </p>

                        </div>
                        <hr>
                        <div class="col-12 flexbox form-check mt-3">
                            <input type="radio" class="radio-custom m-0" id="servicea" name="offerservice"
                                [value]="false" [(ngModel)]="selectedProposal" (change)='onProposalChange($event)' />
                            <label translate class="text-dark ml-2 bold font17 mt-1" for="servicea">
                                lblNextService
                                <br />
                                <span *ngIf="NextKilometer" translate>
                                    lblNextKm
                                    <span>
                                        : {{NextKilometer}}
                                    </span>
                                </span>
                                <br />
                                <span *ngIf="NextDate" translate>
                                    lblNextDate
                                    <span>
                                        : {{ NextDate | date: 'dd.MM.yyyy' }}
                                    </span>
                                </span>

                            </label>
                        </div>
                        <div class="col-12 form-check mt-2"
                            *ngIf="serviceProposal && serviceProposal.nextServiceInfo && serviceProposal.nextServiceInfo.length > 0">

                            <p class="font14 form-check italic" *ngFor="let item of serviceProposal.nextServiceInfo"
                                [id]="item.workId">
                                <em class="fas fa-check"></em> {{ item.serviceName}}
                            </p>

                        </div>
                    </div>
                </div>
            </ng-cotainer>
            <ng-cotainer (click)="getVehicleServiceList();" *ngIf="selectedtab==4">
                <div class="pad15 ctm-tab custom-card">
                    <div class="card-accord">
                        <ngb-accordion #a="ngbAccordion" activeIds="first">
                            <ngb-panel id="first">
                                <ng-template ngbPanelHeader class="custom-header ctm">
                                    <div class="d-flex align-items-center">
                                        <button ngbPanelToggle translate
                                            class="btn d-flex w-100 align-items-center text-left"
                                            aria-label="Center Align" translate aria-expanded="true">
                                            lblMainService
                                            <ng-container *ngIf="!a.activeIds.includes('first')"><em
                                                    class="fas fa-angle-down fa-lg ml-auto"></em>
                                            </ng-container>
                                            <ng-container *ngIf="a.activeIds.includes('first')"><em
                                                    class="fas fa-angle-up fa-lg ml-auto"></em>
                                            </ng-container>
                                        </button>
                                    </div>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <div class="row" *ngIf="vehicleWorkModel && vehicleWorkModel.services">

                                        <div class="col-12 py-3 border-bottom"
                                            *ngFor="let item of vehicleWorkModel.services">

                                            <h4 class="title16 text-uppercase" [for]="item.itemMpId">
                                                {{item.serviceText}}
                                            </h4>

                                            <div class="mt-0" *ngFor="let work of item.workSteps">


                                                <div class="flexbox form-check pl-0 mt-2">

                                                    <input type="radio" class="radio-custom m-0" name="work"
                                                        [id]="work.itemMpId" [value]="work.workId"
                                                        [(ngModel)]="selectedService"
                                                        (change)="mainServiceChanged(work)" (click)="getParts(work)" />
                                                    <label class="text-dark ml-2 font17"
                                                        [for]="work.itemMpId">{{work.workLabourInfoText}}
                                                    </label>
                                                </div>
                                                <div class="mt-2"
                                                    [ngClass]="{'disabledDiv' : work.workId != selectedService}">
                                                    <app-tec-rmi-part-detail [tecDocType]="tecDocType"
                                                        *ngIf="work.showParts == true" [workStepId]="work.workId"
                                                        [workPartList]="work.parts"
                                                        (addCartPart)="addPartToCart($event)"
                                                        (removeCartPart)="removePartFromCart($event)"
                                                        (setPartsToWork)="setPartListForWork($event)">
                                                    </app-tec-rmi-part-detail>
                                                </div>


                                            </div>

                                        </div>

                                    </div>
                                </ng-template>
                            </ngb-panel>
                            <ngb-panel id="second">
                                <ng-template ngbPanelHeader class="custom-header ctm">
                                    <div class="d-flex align-items-center">
                                        <button ngbPanelToggle translate
                                            class="btn d-flex w-100 align-items-center text-left"
                                            aria-label="Center Align" translate>
                                            lblAdditionalService
                                            <ng-container *ngIf="!a.activeIds.includes('second')"><em
                                                    class="fas fa-angle-down fa-lg ml-auto"></em>
                                            </ng-container>
                                            <ng-container *ngIf="a.activeIds.includes('second')"><em
                                                    class="fas fa-angle-up fa-lg ml-auto"></em>
                                            </ng-container>
                                        </button>
                                    </div>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <div class="mb-2 row" [ngClass]="{'disabledDiv' : !selectedService}"
                                        *ngIf="vehicleWorkModel && vehicleWorkModel.additionalWorks">

                                        <div class="col-12 border-bottom py-3"
                                            *ngFor="let item of vehicleWorkModel.additionalWorks">

                                            <h2 class="bold font14" [for]="item.itemMpId">
                                                {{item.serviceText}}
                                            </h2>



                                            <div class="" *ngFor="let work of item.workSteps">
                                                <div class="flexbox form-check pl-0 mt-2">

                                                    <input type="checkbox" class="radio-custom" name="additioanlWork"
                                                        [id]="work.workId" [value]="work.workId"
                                                        [(ngModel)]="work.isChecked"
                                                        (change)="ManageCartServices($event)" />
                                                    <label class="form-check-label"
                                                        [for]="work.workId">{{work.workLabourInfoText}}
                                                    </label>

                                                    <button type="button" class="btn btn-outline-primary ml-auto"
                                                        (click)="getParts(work)" translate>
                                                        <em class="mr5 fas fa-toolbox"></em>
                                                        lblGetParts</button>

                                                </div>
                                                <div class="mt-3 mb-3"
                                                    *ngIf="work.exclusiveWorkPositions && work.exclusiveWorkPositions.length > 0">
                                                    <h4 class="bold font14">Contains</h4>
                                                    <div class="flexbox form-check"
                                                        *ngFor="let exclWork of work.exclusiveWorkPositions">
                                                        <label class="form-check-label"
                                                            [for]="exclWork.workId">{{exclWork.workLabourInfoText}}
                                                        </label>
                                                    </div>
                                                </div>

                                                <app-tec-rmi-part-detail *ngIf="work.showParts == true"
                                                    [tecDocType]="tecDocType" [workStepId]="work.workId"
                                                    [workPartList]="work.parts" (addCartPart)="addPartToCart($event)"
                                                    (removeCartPart)="removePartFromCart($event)"
                                                    (setPartsToWork)="setPartListForWork($event)">
                                                </app-tec-rmi-part-detail>

                                            </div>


                                        </div>

                                    </div>
                                </ng-template>
                            </ngb-panel>

                        </ngb-accordion>
                    </div>
                </div>
            </ng-cotainer>
            <ng-cotainer (click)="getCartDetails();" *ngIf="selectedtab==5">
                <div class="pad15 ctm-tab custom-card">
                    <div class="card-accord">
                        <ngb-accordion #b="ngbAccordion" [activeIds]="openPanels">
                            <ngb-panel id="first-panel">
                                <ng-template ngbPanelHeader class="custom-header ctm">
                                    <div class="btn w-100 align-items-center text-left">

                                        <div class="form-row d-flex align-items-center">
                                            <div class="col-auto wd-50">
                                                <button ngbPanelToggle class="" aria-label="Center Align">
                                                    <ng-container *ngIf="!b.activeIds.includes('first-panel')"><em
                                                            class="fas fa-angle-down font20 ml-auto"></em>
                                                    </ng-container>
                                                    <ng-container *ngIf="b.activeIds.includes('first-panel')"><em
                                                            class="fas fa-angle-up font20 ml-auto"></em>
                                                    </ng-container>
                                                </button>
                                            </div>
                                            <div class="col-md-4 txt" translate>
                                                lblMainService
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblHours
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblPrice
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblSum
                                            </div>
                                            <div class="col-auto ml-auto txt" style="padding-right: 6px;">
                                                Action
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <ul>
                                        <li *ngFor="let item of cartMainServices">
                                            <div class="form-row">
                                                <div class="col-auto wd-50">
                                                    <img src="../../../../../assets/images/no-image-icon.png" width="40"
                                                        alt="">
                                                </div>
                                                <div class="col-md-4">
                                                    <p class="font16 bold">{{item.workInfoText}}</p>
                                                    <p> <label translate>lblLabourPosNo </label> <label> :
                                                            {{item.workPosNo}}</label></p>
                                                    <div *ngIf="item.exclusiveWorkPositions && item.exclusiveWorkPositions.length > 0"
                                                        class="mt-3 mb-3">
                                                        <h4 class="bold font14">Contains</h4>

                                                        <p class="font14"
                                                            *ngFor="let exclWork of item.exclusiveWorkPositions"
                                                            [id]="exclWork.workId">
                                                            {{exclWork.workLabourInfoText}}

                                                        </p>

                                                    </div>
                                                </div>
                                                <div class="col-md-2">
                                                    <p class="font14">{{item.workTime}} h</p>
                                                </div>
                                                <div class="col-md-2">
                                                    <p class="font14">€ 0</p>
                                                </div>
                                                <div class="col-md-2">
                                                    <p class="bold font14">€ 0</p>
                                                </div>
                                                <div class="col-auto ml-auto" style="padding-right: 6px;">
                                                    <button class="btn btn-ico" aria-label="Center Align"
                                                        (click)="removeMainService(item)">
                                                        <em class="far fa-trash-alt fa-lg"></em>
                                                    </button>
                                                </div>
                                            </div>

                                        </li>
                                    </ul>
                                </ng-template>
                            </ngb-panel>
                            <ngb-panel id="second-panel">
                                <ng-template ngbPanelHeader class="custom-header ctm">
                                    <div class="btn w-100 align-items-center text-left">
                                        <div class="form-row d-flex align-items-center">
                                            <div class="col-auto wd-50">
                                                <button ngbPanelToggle class="" aria-label="Center Align">
                                                    <ng-container *ngIf="!b.activeIds.includes('second-panel')"><em
                                                            class="fas fa-angle-down fa-lg ml-auto"></em>
                                                    </ng-container>
                                                    <ng-container *ngIf="b.activeIds.includes('second-panel')"><em
                                                            class="fas fa-angle-up fa-lg ml-auto"></em>
                                                    </ng-container>
                                                </button>
                                            </div>
                                            <div class="col-md-4 txt" translate>
                                                lblAdditionalService
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblHours
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblPrice
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblSum
                                            </div>
                                            <div class="col-auto ml-auto txt" style="padding-right: 6px;">
                                                Action
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template ngbPanelContent>


                                    <div class="form-row" *ngFor="let item of cartAdditionalServices">
                                        <div class="col-auto wd-50">
                                            <img src="../../../../../assets/images/no-image-icon.png" width="40" alt="">
                                        </div>
                                        <div class="col-md-4">
                                            <p class="font16 bold">{{item.workInfoText}}</p>
                                            <p> <label translate>lblLabourPosNo </label> <label class="bold"> :
                                                    {{item.workPosNo}}</label></p>
                                            <div *ngIf="item.exclusiveWorkPositions && item.exclusiveWorkPositions.length > 0"
                                                class="mt-3 mb-3">
                                                <h4 class="bold font14">Contains</h4>

                                                <p class="font14" *ngFor="let exclWork of item.exclusiveWorkPositions"
                                                    [id]="exclWork.workId">
                                                    {{exclWork.workLabourInfoText}}
                                                </p>

                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <p class="font14">{{item.workTime}} h</p>
                                        </div>
                                        <div class="col-md-2">
                                            <p class="font14">€ 0</p>
                                        </div>
                                        <div class="col-md-2">
                                            <p class="bold font14">€ 0</p>
                                        </div>
                                        <div class="col-auto ml-auto" style="padding-right: 6px;">
                                            <button class="btn btn-ico" aria-label="Center Align"
                                                (click)="removeExtraService(item)">
                                                <em class="far fa-trash-alt fa-lg"></em>
                                            </button>
                                        </div>
                                    </div>

                                </ng-template>
                            </ngb-panel>
                            <ngb-panel id="third-panel">
                                <ng-template ngbPanelHeader class="custom-header ctm">
                                    <div class="btn w-100 align-items-center text-left">

                                        <div class="form-row d-flex align-items-center">
                                            <div class="col-auto wd-50">
                                                <button ngbPanelToggle class="" aria-label="Center Align">
                                                    <ng-container *ngIf="!b.activeIds.includes('third-panel')"><em
                                                            class="fas fa-angle-down fa-lg ml-auto"></em>
                                                    </ng-container>
                                                    <ng-container *ngIf="b.activeIds.includes('third-panel')"><em
                                                            class="fas fa-angle-up fa-lg ml-auto"></em>
                                                    </ng-container>
                                                </button>
                                            </div>
                                            <div class="col-md-4 txt" translate>
                                                lblTecRMIParts
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblQuantity
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblPrice
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblSum
                                            </div>
                                            <div class="col-auto ml-auto txt" style="padding-right: 6px;">
                                                Action
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <ul>
                                        <li *ngFor="let item of cartPartItems">
                                            <div class="form-row">
                                                <div class="col-auto wd-50">
                                                    <img src="../../../../../assets/images/no-image-icon.png" width="40"
                                                        alt="">
                                                </div>
                                                <div class="col-md-4">
                                                    <p class="font16 bold">{{item.partName}}</p>
                                                    <p> <label translate>lblPartNumber </label> <label class="bold"> :
                                                            {{item.partNo}}</label></p>
                                                </div>
                                                <div class="col-md-2">
                                                    <p class="font14">{{item.qty}}{{item.qtyType}}</p>
                                                </div>
                                                <div class="col-md-2">
                                                    <p class="font14">€ 0</p>
                                                </div>
                                                <div class="col-md-2">
                                                    <p class="bold font14">€ 0</p>
                                                </div>
                                                <div class="col-auto ml-auto" style="padding-right: 6px;">
                                                    <button class="btn btn-ico" aria-label="Center Align"
                                                        (click)="removePartFromCart(item)">
                                                        <em class="far fa-trash-alt fa-lg"></em>
                                                    </button>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </ng-template>
                            </ngb-panel>
                        </ngb-accordion>
                    </div>
                </div>
            </ng-cotainer>

            <!-- Stock balance tab -->
            <ng-cotainer (click)="getCartDetails();" *ngIf="selectedtab==6">
                <div class="pad15 ctm-tab custom-card">
                    <div class="card-accord">
                        <ngb-accordion #b="ngbAccordion" [activeIds]="openPanels">
                            <ngb-panel id="first-panel">
                                <ng-template ngbPanelHeader class="custom-header ctm">
                                    <div class="btn w-100 align-items-center text-left">

                                        <div class="form-row d-flex align-items-center">
                                            <div class="col-auto wd-50">
                                                <button ngbPanelToggle class="" aria-label="Center Align">
                                                    <ng-container *ngIf="!b.activeIds.includes('first-panel')"><em
                                                            class="fas fa-angle-down font20 ml-auto"></em>
                                                    </ng-container>
                                                    <ng-container *ngIf="b.activeIds.includes('first-panel')"><em
                                                            class="fas fa-angle-up font20 ml-auto"></em>
                                                    </ng-container>
                                                </button>
                                            </div>
                                            <div class="col-md-4 txt" translate>
                                                lblArticle
                                            </div>
                                            <div class="col-md-2 txt" translate>
                                                lblBrand
                                            </div>
                                            <div class="col-md-1 txt" translate>
                                                lblKahaStock
                                            </div>
                                            <div class="col-md-1 txt" translate>
                                                lblLocalStock
                                            </div>
                                            <div class="col-md-1 txt" translate>
                                                lblUnitPrice
                                            </div>
                                            <div class="col-md-1 txt" translate>
                                                lblQtyShort
                                            </div>
                                            <div class="col-auto ml-auto txt">
                                                Action
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <div *ngFor="let stock of displayStockDetails; let j = index">
                                        <div class="font16 bg-highlight-title bold">{{stock.name}}</div>
                                        <ul>
                                            <li *ngFor="let item of stock.stockDetails; let i = index">
                                                <div class="form-row align-items-center">
                                                    <div class="col-auto wd-50">
                                                        <img src="../../../../../assets/images/no-image-icon.png"
                                                            width="40" alt="">
                                                    </div>
                                                    <div class="col-md-4">
                                                        <p class="font14"> <label translate>Article No</label> <label> :
                                                                {{item.number}}</label></p>
                                                        <div *ngIf="item.exclusiveWorkPositions && item.exclusiveWorkPositions.length > 0"
                                                            class="mt-3 mb-3">
                                                            <h4 class="bold font14">Contains</h4>

                                                            <p class="font14"
                                                                *ngFor="let exclWork of item.exclusiveWorkPositions"
                                                                [id]="exclWork.workId">
                                                                {{exclWork.workLabourInfoText}}

                                                            </p>

                                                        </div>
                                                    </div>
                                                    <div class="col-md-2">
                                                        <p class="font14">{{item.brand}} </p>
                                                    </div>
                                                    <div class="col-md-1">
                                                        <p class="font14">{{item.stockLevel}} </p>
                                                    </div>
                                                    <div class="col-md-1">
                                                        <p class="font14">{{item.localStock}}</p>
                                                    </div>
                                                    <div class="col-md-1">
                                                        <p class="bold font14">{{item.listPrice}}</p>
                                                    </div>
                                                    <div class="col-md-1">
                                                        <input class="form-control customize-textbox size text-right"
                                                            style="float: right;" type="text" [value]="item.qty"
                                                            [(ngModel)]="item.qty" maxlength="5"
                                                            (keypress)="isValidQty($event)"
                                                            (ngModelChange)="checkQty($event, item)" />
                                                    </div>
                                                    <div class="col-auto ml-auto">
                                                        <div class="form-check pl-0">
                                                            <input type="checkbox" class="radio-custom"
                                                                id="addRemoveArticleToCart{{item.number}}"
                                                                (change)="addRemoveArticleToCart($event,item)"
                                                                [(ngModel)]="item.isChecked" />
                                                        </div>
                                                    </div>
                                                </div>

                                            </li>
                                        </ul>
                                    </div>
                                </ng-template>
                            </ngb-panel>
                        </ngb-accordion>
                    </div>
                </div>
            </ng-cotainer>
        </div>
    </div>

</div>
<div class="modal-footer" style="align-items: normal;    flex-flow: column;">
    <div class="row">
        <div class="col-auto">
            <button type="button" class="btn btn-primary" translate (click)="showPreviousTab()">lblPrevious</button>
        </div>
        <div class="col-auto ml-auto">
            <button type="button" class="btn btn-primary" [disabled]="
            (selectedtab == 1 && filterModel.kindOfGearBox == null) || 
            (selectedtab == 2 && filterModel.cooGroupId == null)|| 
            (selectedtab == 6 && isErrorOnStockBalanceStep == true)" translate (click)="showNextTab()">lblNext
                <em class="fa-solid fa-angles-right"></em>
            </button>
        </div>
    </div>
</div>